import { render, staticRenderFns } from "./RirekishoBeautyPreview.vue?vue&type=template&id=27046bb6"
import script from "./RirekishoBeautyPreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./RirekishoBeautyPreview.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports